(function () {
  'use strict';

  function getProductData(section) {
    var json = section && section.querySelector('[data-product-json]');
    if (!json) return null;
    try {
      return JSON.parse(json.textContent).product || null;
    } catch (error) {
      return null;
    }
  }

  function getOptionElements(form) {
    return Array.prototype.slice.call(form.querySelectorAll('.ProductForm__Option--ss-buttons'));
  }

  function getSelectedOptions(form) {
    return getOptionElements(form).map(function (optionElement) {
      var selected = optionElement.querySelector('.SSVariantButton.is-selected');
      if (selected) return selected.getAttribute('data-value') || selected.textContent.trim();
      var current = optionElement.querySelector('.ProductForm__SelectedValue');
      return current ? current.textContent.trim() : '';
    });
  }

  function findVariant(product, selectedOptions) {
    if (!product || !product.variants) return null;
    for (var i = 0; i < product.variants.length; i += 1) {
      var variant = product.variants[i];
      var options = variant.options || [];
      var matches = true;
      for (var j = 0; j < selectedOptions.length; j += 1) {
        if (String(options[j]) !== String(selectedOptions[j])) {
          matches = false;
          break;
        }
      }
      if (matches) return variant;
    }
    return null;
  }

  function findVariantById(product, id) {
    if (!product || !product.variants) return null;
    for (var i = 0; i < product.variants.length; i += 1) {
      if (String(product.variants[i].id) === String(id)) return product.variants[i];
    }
    return null;
  }

  function dispatchChange(select) {
    var event;
    try {
      event = new Event('change', { bubbles: true });
    } catch (error) {
      event = document.createEvent('Event');
      event.initEvent('change', true, false);
    }
    select.dispatchEvent(event);
  }

  function formatMoney(cents) {
    if (window.Currency && typeof window.Currency.formatMoney === 'function') {
      return window.Currency.formatMoney(cents, window.theme && window.theme.moneyFormat);
    }
    return (Number(cents || 0) / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  function syncAvailability(form, section, variant) {
    if (!form || !section || !variant) return;

    var addButton = form.querySelector('.ProductForm__AddToCart');
    var paymentButton = form.querySelector('.shopify-payment-button');
    var available = variant.available === true;

    if (addButton) {
      addButton.disabled = !available;
      addButton.classList.toggle('Button--primary', available);
      addButton.classList.toggle('Button--secondary', !available);

      if (available) {
        addButton.setAttribute('data-action', 'add-to-cart');
        addButton.innerHTML = '<span>' + ((window.languages && window.languages.productFormAddToCart) || 'In den Warenkorb') + '</span><span class="Button__SeparatorDot"></span><span data-money-convertible>' + formatMoney(variant.price) + '</span>';
      } else {
        addButton.removeAttribute('data-action');
        addButton.textContent = (window.languages && window.languages.productFormSoldOut) || 'Ausverkauft';
      }
    }

    if (paymentButton) {
      paymentButton.style.display = available ? '' : 'none';
    }

    form.setAttribute('data-ss-variant-available', available ? 'true' : 'false');
  }

  function selectVisibleButton(button) {
    var optionElement = button.closest('.ProductForm__Option--ss-buttons');
    var form = button.closest('form.ProductForm');
    var section = button.closest('[data-section-type="product"]');
    if (!optionElement || !form || !section) return;

    var value = button.getAttribute('data-value') || button.textContent.trim();
    optionElement.querySelectorAll('.SSVariantButton').forEach(function (item) {
      var selected = item === button;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    var selectedValue = optionElement.querySelector('.ProductForm__SelectedValue');
    if (selectedValue) selectedValue.textContent = value;

    var nativeSelect = form.querySelector('select[name="id"]');
    if (!nativeSelect) return;

    var product = getProductData(section);
    var selectedOptions = getSelectedOptions(form);
    var variant = findVariant(product, selectedOptions);
    if (!variant) return;

    nativeSelect.value = String(variant.id);
    dispatchChange(nativeSelect);
    syncAvailability(form, section, variant);
  }

  function initAvailability() {
    document.querySelectorAll('[data-section-type="product"]').forEach(function (section) {
      var form = section.querySelector('form.ProductForm');
      if (!form) return;
      var product = getProductData(section);
      var select = form.querySelector('select[name="id"]');
      var hidden = form.querySelector('input[name="id"]');
      var id = select ? select.value : (hidden ? hidden.value : null);
      var variant = findVariantById(product, id);
      if (variant) syncAvailability(form, section, variant);
    });
  }

  var lastTouch = 0;

  document.addEventListener('touchend', function (event) {
    var button = event.target.closest && event.target.closest('.SSVariantButton');
    if (!button) return;
    lastTouch = Date.now();
    event.preventDefault();
    selectVisibleButton(button);
  }, { passive: false, capture: true });

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.SSVariantButton');
    if (!button) return;
    if (Date.now() - lastTouch < 700) return;
    event.preventDefault();
    selectVisibleButton(button);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form.ProductForm')) return;
    if (form.getAttribute('data-ss-variant-available') === 'false') {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAvailability);
  } else {
    initAvailability();
  }

  document.addEventListener('shopify:section:load', initAvailability);
}());
